<template>
  <div>
    <el-dialog title="AI智能匹配"
               :visible.sync="dialogVisible"
               :width="width"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="VisibleClose('x')"
               center>
      <div class="btn"
           v-if="width == '510px'">
        <el-button type="text"
                   @click="back">重新匹配</el-button>
        <!-- <el-button type="text" @click="listSwitch" v-if="moreFlag"
          >查看更多</el-button
        > -->
      </div>
      <el-form ref="form"
               :model="form"
               :inline="true"
               :rules="rules"
               v-enterToNext="true"
               v-show="!flag && width == '350px' && !loading">
        <el-form-item label="职位名称"
                      prop="name">
          <el-input v-model="form.name"
                    placeholder="请输入内容"
                    style="width: 202px"></el-input>
        </el-form-item>

        <el-form-item label="职业等级"
                      prop="rank">
          <!-- <el-input
            v-model="form.rank"
            placeholder="请输入内容"
            style="width: 100%"
          ></el-input> -->
          <el-select v-model="form.rank"
                     placeholder="请选择"
                     clearable>
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="loading"
           class="AILoading">
        <span class="AiText">思考中</span>
        <img src="@/assets/img/loading.gif"
             alt="" />
      </div>

      <div v-if="listFlag && postitionList.length > 0"
           style="height: 290px; overflow: auto">
        <el-collapse-transition>
          <div class="standardList"
               v-show="flag">
            <div :class="['list', { active: active == i }]"
                 v-for="(item, i) in postitionList"
                 :key="i"
                 @click.stop="changeActive(i, item)">
              <div style="display: flex">
                <el-checkbox v-model="item.checked"
                             @click.stop.native="() => {}"
                             @change="changeActive(i, item)"></el-checkbox>
                <el-tooltip class="item"
                            effect="dark"
                            :content="item.standardName"
                            placement="top"
                            :open-delay="600">
                  <span class="standardName"> {{ item.standardName }}</span>
                </el-tooltip>
              </div>

              <span>职业等级：{{ item.standardRank }}</span>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <el-empty v-if="listFlag && postitionList.length <= 0"
                description="未匹配到数据"></el-empty>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   plain
                   size="mini"
                   @click="mate"
                   v-if="width == '350px' && !loading">一键匹配</el-button>
        <el-button type="primary"
                   plain
                   size="mini"
                   @click="enter"
                   v-if="listFlag">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入组件才能使用
  components: {},
  props: {
    visible: Boolean,
    posName: null,
    //1:跳过表单也  2：先显示表单页
    type: null,
    industry: null,
  },
  data () {
    return {
      dialogVisible: false,
      width: "350px",
      //判断展示内容的标识
      flag: false,
      rules: {},
      form: {},
      //显示数据的表示
      listFlag: false,
      //加载表示
      loading: false,
      postitionList: [],
      //高亮表示
      active: 0,
      //选择的数据
      selectValue: "",
      //更多的标识
      moreFlag: true,
      options: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
      ],
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {
    visible (val) {
      this.dialogVisible = val;
      if (this.type == 1 && val) {
        this.$set(this.form, "name", this.posName);
        this.PositionSetMatchList();
      }
    },
    posName (val) {
      this.$set(this.form, "name", val);
    },
  },
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () { },
  // 方法集合
  methods: {
    PositionSetMatchList () {
      this.loading = true;

      let sendData = {
        topNum: "20",
        loading: false,
      };
      if (this.industry) {
        sendData.industry = this.form.industry;
      }
      if (this.form.name) {
        sendData.name = this.form.name;
      }
      if (this.form.rank) {
        sendData.rank = this.form.rank;
      }
      this.$api.smartAi.PositionSetMatchList(sendData).then((res) => {
        if (res.code == 0) {
          res.data.forEach((element, i) => {
            if (i == 0) {
              this.$set(element, "checked", true);
              this.selectValue = element;
            } else {
              this.$set(element, "checked", false);
            }
          });
          this.postitionList = res.data;
          setTimeout(() => {
            this.width = "510px";
            this.listFlag = true;
            this.loading = false;
          }, 1000);
          setTimeout(() => {
            this.flag = true;
          }, 1100);
        }
      });
    },
    back () {
      this.flag = false;
      this.width = "350px";
      this.listFlag = false;
      this.moreFlag = true;
      this.selectValue = "";
    },
    listSwitch () {
      this.loading = true;
      this.flag = false;
      this.listFlag = false;
      this.moreFlag = false;
      this.selectValue = "";
      let sendData = {
        // industry: this.industry,
        topNum: "20",
      };
      if (this.form.name) {
        sendData.keyWord = this.form.name;
      }
      if (this.form.rank) {
        sendData.rank = this.form.rank;
      }
      this.$api.smartAi.StandardPositionList(sendData).then((res) => {
        if (res.code == 0) {
          res.data.forEach((element, i) => {
            this.$set(element, "standardName", element.name);
            this.$set(element, "standardRank", element.rank);
            this.$set(element, "checked", false);
          });

          this.postitionList.push(...res.data);
          setTimeout(() => {
            this.flag = true;
            this.loading = false;
            this.listFlag = true;
          }, 1000);
        }
      });
    },
    VisibleClose (flag) {
      this.form = {};
      this.listFlag = false;
      this.flag = false;
      this.loading = false;
      this.moreFlag = true;
      this.selectValue = "";
      this.width = "350px";
      if (this.type == 1 || flag == "x") {
        this.$emit("close");
      }
    },
    mate () {
      if (!this.form.name && !this.form.rank) {
        this.$message.warning("请填写职位名称或者职位等级");
        return;
      }
      this.PositionSetMatchList();
    },
    changeActive (v, item) {
      this.postitionList.forEach((element, i) => {
        this.$set(element, "checked", false);
      });
      this.$set(item, "checked", true);
      this.active = v;
      this.selectValue = item;
    },
    PositionSetMatchEdit (value) {
      let sendData = {
        industry: this.industry,
        standardName: value.standardName,
        standardRank: value.standardRank,
        matchName: this.form.name,
        occupationCode: value.occupationCode,
      };
      this.$api.smartAi.PositionSetMatchEdit(sendData).then((res) => {
        if (res.code == 0) {

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    enter () {
      if (!this.selectValue) {
        this.$message.warning("请选择一条标准职位");
      }
      this.PositionSetMatchEdit(this.selectValue);
      this.$emit("enter", this.selectValue, this.form.name);
      this.VisibleClose();
    },
  },
};
</script>
<style lang='less' scoped>
.btn {
  display: flex;
  justify-content: space-between;
}
.AILoading {
  position: relative;
  .AiText {
    position: absolute;
    top: 59px;
    left: 31%;
    font-size: 18px;
    color: #409eff;
  }
  img {
    width: 184px;
    margin-left: 33%;
  }
}
.standardList {
  .list {
    display: flex;
    justify-content: space-between;
    padding: 12px;
    border: 1px solid #e4e7ed;
    border-radius: 10px;
    margin-bottom: 15px;
    cursor: pointer;
  }
  .standardName {
    max-width: 294px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 10px;
  }
  .active {
    border-color: #048cf8;
  }
}
</style>